$(() => {

  $('.bs-blurb__container').each((index, element) => {
    if (!$(element).children('.bs-blurb__trigger').length) {
      $(element).addClass('wrapper-link');
    }
  });

  const $div = $('.bs-section--home-plastics-resources .bs-pro-button__container'),
    divWords = $div.text().split(/\s+/);
  $div.empty();
  $.each(divWords, (i, w) => {
    $('<span/>').text(w).appendTo($div);
  });

  $(".bs-single-post--resource-featured .bs-post__details").each((index, element) => {
    $(element).children().not('.bs-post__image').wrapAll("<div class='content-wrapper' />");
  });

  $('.bs-pro-button').each((index, element) => {
    if ($(element).children('.bs-pro-button__prefix').length) {
      $(element).children('.bs-pro-button__prefix').prependTo($(element).children('.bs-pro-button__container'));
      $(element).addClass('has-icon');
    }
  });

});